import React, {useContext, useState, useEffect} from 'react'
import { AppContext } from '../../../App';



// Import Css
import './popUpEnfoque.css';

//Import FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { height } from '@fortawesome/free-brands-svg-icons/fa11ty';



export function PopUpEnfoque({photoPopUp, titlePopUp, iconPopUp, textPopUp, textClassName}) {


    const { 

        // State popUp Enfoque
        popUpOpen,
        setpopUpOpen,
        logoWebMediaPopUp,
        valorPopUp, 
        setValorPopUp

    } = useContext(AppContext);


    const styleBkPopUp = {
        backgroundImage: `url(${photoPopUp})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
     
    }

    return(

        <div className={`${popUpOpen? 'container-popUp-Open' : 'container-popUp' } `} onClick={() => setpopUpOpen(!popUpOpen)}>
            
            <button className='btn-close-popUp'><FontAwesomeIcon icon={faXmark}  onClick={() => setpopUpOpen(!popUpOpen)} /></button>
            
            <div className='box-all-content' >
            
                {/* backgroundImagen portada */}
                <div className='box-portada-popUp' style={styleBkPopUp}> 
                    <div  className={`box-filter-portada ${textClassName}`}>
                        <img className='icon-enfoque-popUp icon-dinamico' src={iconPopUp}></img>   
                        <p className='title-popUp'>{titlePopUp}</p>
                    </div>
                </div>

                <div className='box-info-logo-foot'>

                    <div className='box-text-popUp'>
                        <p className='text-popUp'>{textPopUp}</p>
                    </div>

                    <div className={`line-divisor-popUp ${textClassName}` }></div>

                    <div className='box-logo-foot'>
                        <img className='logo-webmedia-foot' src={logoWebMediaPopUp} />
                    </div>

                </div>

            </div>

        </div>

    );
}